import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { incrementStep } from '../../../../redux/modules/transferFunding/stepActions';
import { beaconPattern } from '../../../../utils/fundingMethod/fundingMethodUtils';
import {
  SSJBeaconButton,
  SSJBeaconInputField,
  SSJBeaconRadioGroup,
  SSJBeaconRadioButton,
} from '../../../Shared/Beacon/Registry';
import useForm from '../../../Shared/hooks/useForm';
import { TransferConstant } from '../../TransferConstant';
import './AccountDetail.scss';
import rightArrow from '../../../../assets/images/beacon-chevron-right.svg';
import {
  putFundingTrackingData,
  getUserFundingInfo,
  convertAccountType,
} from '../../../../redux/modules/fundingTrackingData/fundingTrackingData.module';
import { getPathName } from '../../../../utils/link-helper';
import AutoCompleteCustodians from '../../../Shared/AutoCompleteCustodians/AutoCompleteCustodians';
import config from '../../../../config/config';
import { dispatchPageLoad } from '../../../../redux/utils/analytics-helper';
import iconPencil from '../../../../assets/images/icon_pencil.svg';

const AccountDetail = () => {
  useEffect(() => {
    dispatchPageLoad('Provide Details');
  }, []);
  const dispatch = useDispatch();
  const fundingTrackingData = useSelector(
    (state) => state?.fundingTrackingData
  );
  const [existingAccount, setExistingAccount] = useState(false);
  const [accountType, setAccountType] = useState('');
  const [account, setAccount] = useState({});
  const [isAccountList, setIsAccountList] = useState(false);
  const isExistingTransferAccount = getPathName(window.location.href).includes(
    'existing-account'
  );
  const { values, handleSubmit, handleChange, setValues } = useForm(
    {
      transferToFirmName: TransferConstant.accountDeatilPage.firmNameValue,
      transferToAccountType:
        fundingTrackingData?.store?.userAccountFundingData?.agreementType || '',
      externalFinancialInstitutionNumber:
        fundingTrackingData?.payload?.onboardingDataStore
          ?.onboardingDatastoreTransfer?.externalFinancialInstitutionNumber ||
        '',
      transferToAccountNumber:
        fundingTrackingData?.store?.AccountAgreementNumber || '',
      transferFromAccountType: 'null',
      externalFinancialInstituteName:
        fundingTrackingData?.payload?.onboardingDataStore
          ?.onboardingDatastoreTransfer?.externalFinancialInstituteName || '',
      csdId:
        fundingTrackingData?.payload?.onboardingDataStore
          ?.onboardingDatastoreTransfer?.csdId || '',
      rolloverTopInstitution:
        fundingTrackingData?.payload?.onboardingDataStore
          ?.onboardingDatastoreTransfer?.rolloverTopInstitution || false,
      transferTopInstitution:
        fundingTrackingData?.payload?.onboardingDataStore
          ?.onboardingDatastoreTransfer?.transferTopInstitution || false,
      transferCertificateOfDeposit:
        fundingTrackingData?.payload?.onboardingDataStore
          ?.onboardingDatastoreTransfer?.transferCertificateOfDeposit || false,
    },
    () => {
      // If use selects a Mutual Funds account (!sweep)
      if (existingAccount && !account.sweep) {
        const pathRetirement =
          'personal-investing/tools/nasu/mutual-fund/retirement/transfer';
        const pathGeneralInvesting =
          'personal-investing/tools/nasu/mutual-fund/general-investing/transfer';
        switch (account?.agreementType) {
          case 'ROTH_IRA':
            return (window.location.href = `${config.url}/${pathRetirement}/roth-ira`);
          case 'TRADITIONAL_IRA':
            return (window.location.href = `${config.url}/${pathRetirement}/traditional-ira`);
          case 'ROLLOVER_IRA':
            return (window.location.href = `${config.url}/${pathRetirement}/rollover-ira`);
          case 'INDIVIDUAL':
            return (window.location.href = `${config.url}/${pathGeneralInvesting}/individual`);
          case 'JOINT_TENANT':
            return (window.location.href = `${config.url}/${pathGeneralInvesting}/joint`);
          case 'UGMA_UTMA':
            return (window.location.href = `${config.url}/${pathGeneralInvesting}/ugma-utma`);
          default:
            return;
        }
      }
      if (fundingTrackingData?.payload?.onboardingDataStore) {
        fundingTrackingData.payload.onboardingDataStore.onboardingDatastoreTransfer =
          {
            ...fundingTrackingData.payload.onboardingDataStore
              .onboardingDatastoreTransfer,
            ...values,
          };
      }
      dispatch(putFundingTrackingData(fundingTrackingData?.payload));
      window.scrollTo(0, 0);
      dispatch(incrementStep());
    }
  );

  /* eslint-disable */
  useEffect(() => {
    const url = window.location.href;
    const isExistingAccPage = getPathName(url).includes('existing-account');
    setExistingAccount(isExistingAccPage);
  }, []);

  useEffect(() => {
    setValues({
      ...values,
      transferToAccountType:
        fundingTrackingData?.store?.userAccountFundingData?.agreementType || '',
      transferToAccountNumber:
        fundingTrackingData?.store?.AccountAgreementNumber || '',
      externalFinancialInstituteName:
        fundingTrackingData?.payload?.onboardingDataStore
          ?.onboardingDatastoreTransfer?.externalFinancialInstituteName || '',
      externalFinancialInstitutionNumber:
        fundingTrackingData?.payload?.onboardingDataStore
          ?.onboardingDatastoreTransfer?.externalFinancialInstitutionNumber ||
        '',
    });
  }, [fundingTrackingData?.isLoaded]);

  /* eslint-disable */
  useEffect(() => {
    setValues({
      ...values,
      transferToAccountType:
        fundingTrackingData?.store?.userAccountFundingData?.agreementType,
      transferToAccountNumber:
        fundingTrackingData?.store?.AccountAgreementNumber,
      externalFinancialInstituteName:
        fundingTrackingData?.payload?.onboardingDataStore
          ?.onboardingDatastoreTransfer?.externalFinancialInstituteName || '',
      externalFinancialInstitutionNumber:
        fundingTrackingData?.payload?.onboardingDataStore
          ?.onboardingDatastoreTransfer?.externalFinancialInstitutionNumber ||
        '',
    });
  }, [fundingTrackingData]);

  const handleCDChange = (e) => {
    setValues({
      ...values,
      transferCertificateOfDeposit: e.target.value,
    });
  };

  const handleFinalSubmit = () => {
    if (existingAccount && !account.sweep) {
      handleSubmit();
    }
    const instituteEle = document.querySelector('#externalFiName');
    const instituteNo = document.querySelector(
      '#externalFinancialInstitutionNumber'
    );

    if (
      values?.externalFinancialInstituteName !== '' &&
      values?.externalFinancialInstitutionNumber !== ''
    ) {
      handleSubmit();
    } else {
      instituteEle?.evaluateValidations();
      instituteNo?.evaluateValidations();
    }
  };

  const getAccountOption = (account) => {
    if (account?.sweep) {
      return (
        <div className="mutual-account">
          <p>Brokerage {convertAccountType(account?.agreementType)}</p>
          <p className="mutual-account_descp blocked_data">
            {account?.linkedAgreementNumber} . {account?.formattedEntityNames}
          </p>
        </div>
      );
    } else {
      return (
        <div className="mutual-account">
          <p>Mutual Funds {convertAccountType(account?.agreementType)}</p>
          <p className="mutual-account_descp blocked_data">
            {account?.agreementNumber} . {account?.formattedEntityNames}
          </p>
        </div>
      );
    }
  };

  const handleAccountType = (account) => {
    if (account && account.agreementType) {
      setAccount(account);
      setAccountType(convertAccountType(account?.agreementType));
      setIsAccountList(!isAccountList);
      const agreementID = account?.sweep
        ? account?.linkedAgreementID
        : account?.agreementID;
      // if (account.sweep) {
      dispatch(
        getUserFundingInfo(agreementID, TransferConstant.labels.TRANSFER)
      );
      // }
    }
  };

  useEffect(() => {
    if (
      fundingTrackingData?.store?.AccountAgreementNumber &&
      fundingTrackingData?.store?.AccountAgreementNumber !== ''
    ) {
      fundingTrackingData?.store?.userProductsFundingData.map((account) => {
        if (
          account.linkedAgreementNumber ===
          fundingTrackingData?.store?.AccountAgreementNumber
        ) {
          setAccount(account);
          setAccountType(convertAccountType(account?.agreementType));
        }
      });
    }
  }, [fundingTrackingData?.store?.AccountAgreementNumber]);

  const handleOnClick = () => {
    setIsAccountList(!isAccountList);
  };

  function TransferToFields() {
    if (!existingAccount) {
      return (
        <table className="transfer-account-details_transferTo">
          <tbody>
            <tr className="transfer-account-details_transferTo-details">
              <td className="transfer-account-details_transferTo-details-first">
                {TransferConstant.accountDeatilPage.firmName}
              </td>
              <td className="transfer-account-details_transferTo-details-second">
                <span>{TransferConstant.accountDeatilPage.firmNameValue}</span>
                {isExistingTransferAccount && (
                  <span
                    onClick={() => {
                      setExistingAccount(true);
                      setAccount({});
                      setAccountType('');
                    }}
                  >
                    <img
                      className="transfer-account-details_transferTo-details-second_icon"
                      src={iconPencil}
                      alt="icon-pencil"
                      width="20"
                      height="20"
                    />{' '}
                    Edit{' '}
                  </span>
                )}
              </td>
            </tr>
            <tr className="transfer-account-details_transferTo-details">
              <td className="transfer-account-details_transferTo-details-first">
                {TransferConstant.accountDeatilPage.accountType}
              </td>
              <td className="transfer-account-details_transferTo-details-second">
                {fundingTrackingData?.store?.normalizedAccountType}
              </td>
            </tr>
            <tr className="transfer-account-details_transferTo-details">
              <td className="transfer-account-details_transferTo-details-first">
                {TransferConstant.accountDeatilPage.accountNumber}
              </td>
              <td className="transfer-account-details_transferTo-details-second blocked_data">
                {values?.transferToAccountNumber}
              </td>
            </tr>
          </tbody>
        </table>
      );
    }
    if (
      existingAccount &&
      (Object.keys(account).length === 0 ||
        (Object.keys(account).length > 0 && !account?.sweep))
    ) {
      return (
        <div
          className={`input-field_trowe-price-account ${
            account.sweep ? '' : 'mb-3'
          }`}
        >
          <SSJBeaconInputField
            id="trowePriceAccount"
            label="T. Rowe Price Account"
            hint="Identify the T. Rowe Price account you want to move assets into."
            name="externalFiName"
            icon-url={rightArrow}
            icon-position="right"
            required="true"
            value={accountType}
            placeholder="Choose an Account"
            onBlur={handleAccountType}
            onClick={handleOnClick}
            onKeyPress={handleOnClick}
            errors-map='{"required":"T.Rowe Price Account is required!"}'
          />
          {isAccountList && (
            <ul className="suggestions account-suggestions">
              {fundingTrackingData?.store?.userProductsFundingData?.map(
                (account) =>
                  TransferConstant.existingAccountTypes.includes(
                    account?.agreementType
                  ) && (
                    <div key={`parentEl-${account?.agreementID}`}>
                      <li
                        key={account?.agreementID}
                        onClick={() => handleAccountType(account)}
                        onKeyPress={() => handleAccountType(account)}
                        tabIndex="0"
                      >
                        {getAccountOption(account)}
                      </li>
                      <div
                        key={`line-${account?.agreementID}`}
                        className="line-thin"
                      />
                    </div>
                  )
              )}
            </ul>
          )}
        </div>
      );
    }

    if (existingAccount && Object.keys(account).length > 0 && account.sweep) {
      return (
        <table className="transfer-account-details_transferTo">
          <tbody>
            <tr className="transfer-account-details_transferTo-details">
              <td className="transfer-account-details_transferTo-details-first">
                {TransferConstant.accountDeatilPage.firmName}
              </td>
              <td className="transfer-account-details_transferTo-details-second">
                <span>{TransferConstant.accountDeatilPage.firmNameValue}</span>
                {isExistingTransferAccount && (
                  <span
                    onClick={() => {
                      setExistingAccount(true);
                      setAccount({});
                      setAccountType('');
                    }}
                  >
                    <img
                      className="transfer-account-details_transferTo-details-second_icon"
                      src={iconPencil}
                      alt="icon-pencil"
                      width="20"
                      height="20"
                    />{' '}
                    Edit{' '}
                  </span>
                )}
              </td>
            </tr>
            <tr className="transfer-account-details_transferTo-details">
              <td className="transfer-account-details_transferTo-details-first">
                {TransferConstant.accountDeatilPage.accountType}
              </td>
              <td className="transfer-account-details_transferTo-details-second">
                {convertAccountType(account?.agreementType)}
              </td>
            </tr>
            <tr className="transfer-account-details_transferTo-details">
              <td className="transfer-account-details_transferTo-details-first">
                {TransferConstant.accountDeatilPage.accountNumber}
              </td>
              <td className="transfer-account-details_transferTo-details-second blocked_data">
                {account.linkedAgreementNumber}
              </td>
            </tr>
          </tbody>
        </table>
      );
    }
    return <></>;
  }

  return (
    <div className="transfer-account">
      <h2 className="transfer-account_title">
        {TransferConstant.accountDeatilPage.label}
      </h2>
      <p className="transfer-account_desc">
        {TransferConstant.accountDeatilPage.desc1}
      </p>
      <div className="transfer-account-details">
        <h1 className="transfer-account-details_transferTo-title">
          {TransferConstant.accountDeatilPage.transferTo}
        </h1>
        <TransferToFields />
        {/* Default section will be presented OR user selects Brokerage account (sweep)*/}
        {(Object.keys(account).length === 0 || account.sweep) && (
          <>
            <h1 className="transfer-account-details_transferFrom-title">
              {TransferConstant.accountDeatilPage.transferFrom}
            </h1>
            {!existingAccount && (
              <table className="transfer-account-details_transferFrom">
                <tbody>
                  <tr className="transfer-account-details_transferFrom-details">
                    <td className="transfer-account-details_transferFrom-details-first">
                      {TransferConstant.accountDeatilPage.accountType}
                    </td>
                    <td className="transfer-account-details_transferFrom-details-second">
                      {fundingTrackingData?.store?.normalizedAccountType}
                    </td>
                  </tr>
                </tbody>
              </table>
            )}
            <AutoCompleteCustodians
              values={values}
              setValues={setValues}
              variant="transfer"
            />
            <div className="transfer-account-details_account">
              <div>
                <SSJBeaconInputField
                  id="externalFinancialInstitutionNumber"
                  className="blocked_data"
                  type="text"
                  label={
                    TransferConstant.accountDeatilPage.financialAccountNumber
                  }
                  hint={
                    TransferConstant.accountDeatilPage
                      .financialAccountNumberDesc
                  }
                  format-type="pattern"
                  name="externalFinancialInstitutionNumber"
                  required="true"
                  maxlength="25"
                  pattern={beaconPattern.fundingAccountNumberRegex}
                  value={values?.externalFinancialInstitutionNumber}
                  onBlur={handleChange}
                  errors-map='{"required":"You must provide the Account Number"}'
                />
              </div>
            </div>

            <div className="transfer-account-details_transfer-certificate">
              <div>
                <h2 className="transfer-account-details_transfer-certificate-title">
                  {TransferConstant.accountDeatilPage.transferCertificateRadio}
                </h2>
                <div className="transfer-account-details_transfer-certificate-desc">
                  {TransferConstant.accountDeatilPage.transferCertificateDesc}
                </div>
                <SSJBeaconRadioGroup
                  id="transferCertificateOfDeposit"
                  className="transfer-account-details_certificate-radio-group"
                  name="transferCertificateOfDeposit"
                >
                  <SSJBeaconRadioButton
                    label={TransferConstant.accountDeatilPage.No}
                    id={TransferConstant.accountDeatilPage.No}
                    value={false}
                    checked={!values.transferCertificateOfDeposit}
                    onClick={(e) => handleCDChange(e)}
                  />
                  <SSJBeaconRadioButton
                    label={TransferConstant.accountDeatilPage.Yes}
                    id={TransferConstant.accountDeatilPage.Yes}
                    value={true}
                    checked={values.transferCertificateOfDeposit}
                    onClick={(e) => handleCDChange(e)}
                  />
                </SSJBeaconRadioGroup>
              </div>
            </div>
          </>
        )}
        <SSJBeaconButton
          id="continueButton"
          className="transfer-account-details_continue-btn transfer-account-continue-btn"
          label="Continue"
          icon-align="right"
          variant="primary"
          scale="jumbo"
          onClick={handleFinalSubmit}
        >
          <img
            slot="icon"
            icon-align="right"
            alt="Continue Button"
            className="continue-arrow-icon"
            fill="none"
            height="16"
            width="16"
            src={rightArrow}
          />
        </SSJBeaconButton>
      </div>
    </div>
  );
};

export default AccountDetail;
